import { html, ifDefined } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../config.js';
import { customerDataManager, infrastructure, moduleLoader } from '../infrastructure.js';

/**
 * @param {UrlSearchParams} query - object representing query parameters
 * @param {string} anchor - string representing anchor fragment
 * @returns {TemplateResult}
 */
export default function renderESimDeactivationPageTemplate({ query, anchor }) {
  moduleLoader.loadModule(config.teganWidgetUrl);
  const authenticationToken = query.get('code');
  const physicalSimLastFourDigits = query.get('state');
  const hasAuthenticationFailure = query.has('error');

  return html`
    <osk-sim-management-page
      .infrastructure=${infrastructure}
      .query=${query}
      anchor=${ifDefined(anchor)}
      working-sn=${customerDataManager.workingSn}
      operation="deactivation"
      authentication-token=${ifDefined(authenticationToken)}
      physical-sim-last-four-digits=${ifDefined(physicalSimLastFourDigits)}
      ?has-authentication-failure=${hasAuthenticationFailure}
    ></osk-sim-management-page>
  `;
}
